import React from 'react';
import RequestStepInfoContent from './RequestStepInfoContent';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const RequestStepInfo = ({ category, code, section }) => {
  const state = Selectors.useRequestStepInfo({ category, code, section });
  Fetch.useFetchWorkflowForRequest({ category: 'open', code: state.workflowKey, requestCode: code }, state.readStatus);

  return (
    <RequestStepInfoContent
      category={category}
      code={code}
      fields={state.fields}
      name={state.name}
      readErrors={state.readErrors}
      readStatus={state.readStatus}
      request={state.request}
      section={section}
      sourceCode={state.sourceCode}
      sourceType={state.sourceType}
      saveErrors={state.saveErrors}
      saveStatus={state.saveStatus}
    />
  );
};

export default RequestStepInfo;
